// US states + DC with census FIPS codes. Generated from the Census
// Bureau FIPS reference file (https://www2.census.gov/geo/docs/reference/state.txt,
// fetched 2026-06-11); territories (FIPS > 56) excluded. The impact API is
// FIPS-native, so these static tables stand in for any selection-list /
// geography-taxonomy integration.

export interface UsState {
  /** 2-digit census state FIPS. */
  fips: string;
  postal: string;
  name: string;
}

export const US_STATES: UsState[] = [
  { fips: '01', postal: 'AL', name: 'Alabama' },
  { fips: '02', postal: 'AK', name: 'Alaska' },
  { fips: '04', postal: 'AZ', name: 'Arizona' },
  { fips: '05', postal: 'AR', name: 'Arkansas' },
  { fips: '06', postal: 'CA', name: 'California' },
  { fips: '08', postal: 'CO', name: 'Colorado' },
  { fips: '09', postal: 'CT', name: 'Connecticut' },
  { fips: '10', postal: 'DE', name: 'Delaware' },
  { fips: '11', postal: 'DC', name: 'District of Columbia' },
  { fips: '12', postal: 'FL', name: 'Florida' },
  { fips: '13', postal: 'GA', name: 'Georgia' },
  { fips: '15', postal: 'HI', name: 'Hawaii' },
  { fips: '16', postal: 'ID', name: 'Idaho' },
  { fips: '17', postal: 'IL', name: 'Illinois' },
  { fips: '18', postal: 'IN', name: 'Indiana' },
  { fips: '19', postal: 'IA', name: 'Iowa' },
  { fips: '20', postal: 'KS', name: 'Kansas' },
  { fips: '21', postal: 'KY', name: 'Kentucky' },
  { fips: '22', postal: 'LA', name: 'Louisiana' },
  { fips: '23', postal: 'ME', name: 'Maine' },
  { fips: '24', postal: 'MD', name: 'Maryland' },
  { fips: '25', postal: 'MA', name: 'Massachusetts' },
  { fips: '26', postal: 'MI', name: 'Michigan' },
  { fips: '27', postal: 'MN', name: 'Minnesota' },
  { fips: '28', postal: 'MS', name: 'Mississippi' },
  { fips: '29', postal: 'MO', name: 'Missouri' },
  { fips: '30', postal: 'MT', name: 'Montana' },
  { fips: '31', postal: 'NE', name: 'Nebraska' },
  { fips: '32', postal: 'NV', name: 'Nevada' },
  { fips: '33', postal: 'NH', name: 'New Hampshire' },
  { fips: '34', postal: 'NJ', name: 'New Jersey' },
  { fips: '35', postal: 'NM', name: 'New Mexico' },
  { fips: '36', postal: 'NY', name: 'New York' },
  { fips: '37', postal: 'NC', name: 'North Carolina' },
  { fips: '38', postal: 'ND', name: 'North Dakota' },
  { fips: '39', postal: 'OH', name: 'Ohio' },
  { fips: '40', postal: 'OK', name: 'Oklahoma' },
  { fips: '41', postal: 'OR', name: 'Oregon' },
  { fips: '42', postal: 'PA', name: 'Pennsylvania' },
  { fips: '44', postal: 'RI', name: 'Rhode Island' },
  { fips: '45', postal: 'SC', name: 'South Carolina' },
  { fips: '46', postal: 'SD', name: 'South Dakota' },
  { fips: '47', postal: 'TN', name: 'Tennessee' },
  { fips: '48', postal: 'TX', name: 'Texas' },
  { fips: '49', postal: 'UT', name: 'Utah' },
  { fips: '50', postal: 'VT', name: 'Vermont' },
  { fips: '51', postal: 'VA', name: 'Virginia' },
  { fips: '53', postal: 'WA', name: 'Washington' },
  { fips: '54', postal: 'WV', name: 'West Virginia' },
  { fips: '55', postal: 'WI', name: 'Wisconsin' },
  { fips: '56', postal: 'WY', name: 'Wyoming' },
];

export const US_STATE_BY_FIPS: ReadonlyMap<string, UsState> = new Map(
  US_STATES.map((state) => [state.fips, state])
);
